import React, { useEffect, useState } from 'react';
import CampaignModal from '../components/CampaignModal';
import { isCampaignOngoing } from '../utils';

export default () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isNeverShow, setIsNeverShow] = useState(false);

  const onCheckboxChange = (_event, checked) => {
    setIsNeverShow(checked);
  };
  const onClose = () => {
    setIsOpen(false);
    window.localStorage.setItem('isNeverOpenOoha202304Modal', isNeverShow);
  };

  useEffect(() => {
    const isNeverOpenOoha202304Modal = window.localStorage.getItem('isNeverOpenOoha202304Modal');

    setIsOpen(!JSON.parse(isNeverOpenOoha202304Modal));
  }, []);

  if (!isCampaignOngoing()) {
    return <></>;
  }

  return (
    <CampaignModal
      isNeverShow={isNeverShow}
      isOpen={isOpen}
      onCheckboxChange={onCheckboxChange}
      onClose={onClose}
    />
  );
};
